<div class="products-container">
  <!-- Filter bar -->
  <div class="filters">
    <!-- Filter Button -->
    <button class="action-btn secondary-btn" [class.activeFilter]="isFilterActive()" (click)="openFilter()">
      <div class="icon">
        <app-svg-icon svgIcon="filter-cc"></app-svg-icon>
      </div>
      <span>{{ "common.filter" | translate }}</span>
      <div class="clear-icon-container">
        <img
          class="clear-icon"
          *ngIf="isFilterActive()"
          (click)="clearFilter(); $event.stopPropagation()"
          src="assets/icones/clear-icon.svg"
          alt=""
        />
        <div class="clear-tooltip" *ngIf="isFilterActive()">
          {{ "common.clear_filters" | translate }}
        </div>
      </div>
    </button>
    <!-- Search Box -->
    <ui-form-field
      [formControl]="searchInput"
      [suffixIcon]="'search_icon'"
      [placeholder]="'Catalogs.new_catalog.products.listing.search' | translate"
      [fullWidth]="true"
    >
    </ui-form-field>
  </div>

  <div class="empty-products-message" *ngIf="loading">
    <div class="spinner"></div>
  </div>

  <!-- No products message -->
  <div class="empty-products-message" *ngIf="!loading && products.length === 0">
    <div class="message-content">
      <p>{{ "Catalogs.new_catalog.products.listing.no_products_found" | translate }}</p>
    </div>
  </div>

  <!-- Products table -->
  <div class="products-content" *ngIf="products.length > 0">
    <form [formGroup]="productsForm">
      <table class="products-table">
      <thead>
        <tr class="row header" style="padding-top: 10px; border: unset; height: unset">
          <th>
            <mat-checkbox
              class="zero-spacing-checkbox"
              [checked]="isAllProductsSelected()"
              [indeterminate]="isPartialSelectedAll()"
              (change)="toggleAllProducts($event.checked)"
            >
            </mat-checkbox>
          </th>
          <!-- Image -->
          <th>
            {{ "Catalogs.new_catalog.products.listing.img" | translate }}
          </th>
          <!-- Product Name -->
          <th class="sortable-column">
            {{ "quotations_and_orders.product" | translate }}
            <div class="sort-actions">
              <span class="arrow-up" [class.active]="activeSortKey === 'name' && activeSortMode == 'asc'" (click)="sortByKey('name', 'asc')"></span>
              <span
                class="arrow-down"
                [class.active]="activeSortKey === 'name' && activeSortMode == 'desc'"
                (click)="sortByKey('name', 'desc')"
              ></span>
            </div>
          </th>
          <!-- Brand -->
          <th class="sortable-column" *ngIf="infoMode === 'brand'">
            {{ "Catalogs.new_catalog.products.listing.brand" | translate }}
            <div class="sort-actions">
              <span class="arrow-up" [class.active]="activeSortKey === 'brand' && activeSortMode == 'asc'" (click)="sortByKey('brand', 'asc')"></span>
              <span
                class="arrow-down"
                [class.active]="activeSortKey === 'brand' && activeSortMode == 'desc'"
                (click)="sortByKey('brand', 'desc')"
              ></span>
            </div>
          </th>
          <!-- Quantity -->
          <th *ngIf="infoMode === 'quantity'">
            {{ "quotations_and_orders.quantity" | translate }}
          </th>
          <!-- Discount -->
          <th *ngIf="infoMode === 'discount'">
            {{ "quotations_and_orders.discount" | translate }}
          </th>
        </tr>
        <tr class="row header" style="padding-bottom: 10px; height: unset">
          <th></th>
          <!-- Img -->
          <th></th>
          <!-- Product Name -->
          <th>
            <span style="font-weight: 400" class="secondary-text">
              {{ productCode.primaryLabelKey | translate }}/{{ "inventory.barcode_ean" | translate }}
            </span>
          </th>
          <!-- Brand/Quantity -->
          <th></th>
        </tr>
      </thead>
      <tbody>
          <div class="products-viewport">
            <ng-container *ngFor="let product of products; trackBy: trackByProductId">
              <tr class="row">
                <!-- Image -->
                <td>
                  <mat-checkbox
                    [checked]="isProductSelected(product)"
                    (change)="toggleProduct(product, $event.checked)"
                    (click)="$event.stopPropagation()"
                  ></mat-checkbox>
                </td>
                <!-- Image -->
                <td>
                  <img
                    class="thumbmail-image"
                    [class]="!product.image ? 'no-image' : ''"
                    [src]="failedImages.has(product.image!) ? 'assets/icones/default-image-product.svg' : getImage(product.image!)"
                    alt=""
                    (error)="onImageError(product.image!)"
                  />
                </td>
                <!-- Product Name -->
                <td (click)="openDetails(product)" style="cursor: pointer">
                  <div style="display: flex; flex-direction: column">
                    <span class="truncate" [title]="product.name">
                      {{ product.name }}
                    </span>
                    <span class="secondary-text" [title]="(product | productCode) + '/' + (product.barcode || '--')"
                      >{{ product | productCode }}/{{ product.barcode || "--" }}</span
                    >
                  </div>
                </td>
                <!-- Brand -->
                <td *ngIf="infoMode === 'brand'">
                  <span class="truncate" [title]="product.brand?.name || ''">
                    {{ product.brand?.name || "--" }}
                  </span>
                </td>
                <!-- Quantity -->
                <td *ngIf="infoMode === 'quantity'">
                  <ui-form-field
                    type="number"
                    [placeholder]="'0'"
                    [formControlName]="'product_' + product.product_id!"
                    [min]="product.min_qte || null"
                    [max]="product.max_qte || null"
                    [step]="product.increment || 1"
                    [numberAlignment]="'left'"
                    [errorMessages]="{
                      required: 'validation.required' | translate,
                      quantityInvalid: 'quotations_and_orders.quantityInvalid' | translate,
                      quantityMin: 'quotations_and_orders.quantityMin' | translate,
                      quantityMax: 'quotations_and_orders.quantityMax' | translate,
                      quantityIncrement: 'quotations_and_orders.quantityIncrement' | translate
                    }"
                    (input)="onUpdateQuantity($event, product)"
                  ></ui-form-field>
                </td>
                <!-- Discount -->
                <td *ngIf="infoMode === 'discount'">
                  <ui-form-field
                    type="number"
                    [placeholder]="'0'"
                    [formControlName]="'product_' + product.product_id!"
                    [min]="0"
                    [max]="100"
                    [step]="1"
                    [suffixText]="'%'"
                    [numberAlignment]="'right'"
                    [errorMessages]="{
                      required: 'validation.required' | translate,
                      min: ('validation.min' | translate: { min: 0 }),
                      max: ('validation.max' | translate: { max: 100 })
                    }"
                    (input)="onUpdateDiscount($event, product)"
                  ></ui-form-field>
                </td>
              </tr>
            </ng-container>
            <tr *ngIf="hasMore" (click)="loadMore()" class="show-more">
              Show More ({{
                products.length + "/" + productsMetadata?.count
              }})
            </tr>
          </div>
        </tbody>
      </table>
    </form>
  </div>
</div>
